import { useState } from "react";
import {
  Box,
  Typography,
  Stack,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AnswerOption from "./AnswerOption";

export default function QuestionView({
  question,
  answered,
  onSend,
  onNext,
  isLastQuestion
}) {
  const [selected, setSelected] = useState([]);
  const [hypothesis, setHypothesis] = useState("");
  const theme = useTheme();


  const toggleOption = (index) => {
    if (answered) return;

    setSelected((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  const handleSend = () => {
    if (selected.length !== question.correctAnswer.length) {
      alert(
        `Il faut sélectionner ${question.correctAnswer.length} réponse(s)`
      );
      return;
    }

    onSend();
  };

  const handleNext = () => {
    onNext({
      questionId: question.id,
      selected,
      hypothesis,
    });
  };

  return (
    <Box>
      <Typography variant="p" fontWeight={200} sx={{ mb: 1 }}>
        {question.id}
      </Typography>
      <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
        {question.text}
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 3 }}
      >
        {question.correctAnswer.length} réponse(s) attendue(s)
      </Typography>

      <Stack spacing={2}>
        {Object.entries(question.choices).map(([key, choice]) => (
          <AnswerOption
            key={key}
            text={choice}
            selected={selected.includes(key)}
            correct={question.correctAnswer.includes(key)}
            showCorrection={answered}
            explanation={question.explanations?.[key]}
            onClick={() => toggleOption(key)}
          />
        ))}
      </Stack>

      {/* Hypothèse */}
      {!answered && (
        <TextField
          label="Hypothèse (optionnel)"
          multiline
          rows={3}
          fullWidth
          sx={{ mt: 3 }}
          value={hypothesis}
          onChange={(e) => setHypothesis(e.target.value)}
        />
      )}

      <Box sx={{ mt: 4 }}>
  {!answered ? (
    <Button
      variant="contained"
      size="large"
      fullWidth
      onClick={handleSend}
      sx={{background:  theme.custom.gradients.bluePurple}}
    >
      Envoyer
    </Button>
  ) : (
    <Button
      variant="contained"
      size="large"
      fullWidth
      onClick={handleNext}
      sx={{background: isLastQuestion
      ? theme.custom.gradients.aws
      : theme.custom.gradients.green}}
    >
      {isLastQuestion ? "Envoyer le quiz" : "Suivant"}
    </Button>
  )}
</Box>
      

      {answered && hypothesis && (
        <Alert severity="warning" sx={{ mt: 3 }}>
          <strong>Ton hypothèse :</strong> {hypothesis}
        </Alert>
      )}
    </Box>
  );
}
